var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCornerDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.08301 5.33301C6.08301 4.91879 5.74722 4.58301 5.33301 4.58301C4.91879 4.58301 4.58301 4.91879 4.58301 5.33301V11.1663C4.58301 12.2493 5.01321 13.2879 5.77899 14.0537C6.54476 14.8195 7.58337 15.2497 8.66634 15.2497H16.8557L13.9694 18.136C13.6765 18.4289 13.6765 18.9038 13.9694 19.1967C14.2623 19.4896 14.7371 19.4896 15.03 19.1967L19.1967 15.03C19.2748 14.9519 19.332 14.8609 19.3685 14.7639C19.3933 14.698 19.4091 14.6276 19.4144 14.5543C19.417 14.518 19.417 14.4815 19.4144 14.4453C19.4092 14.3721 19.3934 14.3018 19.3687 14.236C19.3322 14.1387 19.2749 14.0476 19.1967 13.9693L15.03 9.80268C14.7371 9.50978 14.2623 9.50978 13.9694 9.80268C13.6765 10.0956 13.6765 10.5704 13.9694 10.8633L16.8557 13.7497H8.66634C7.9812 13.7497 7.32412 13.4775 6.83965 12.993C6.35518 12.5086 6.08301 11.8515 6.08301 11.1663V5.33301Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerDown);
export default __webpack_public_path__ + "static/media/corner-down.1da4f518b994ee658874c14c63699df9.svg";
export { ForwardRef as ReactComponent };